import { STRING_TYPES } from "@/lib/tally";

const inputCls =
  "w-full bg-[#0b0e13] border border-[#334155] focus:border-[#f59e0b] outline-none px-3 py-2 text-sm mono text-[#f8fafc] transition-colors";

export function Field({ label, unit, value, onChange, testid, type = "text", placeholder }) {
  return (
    <label className="block">
      <div className="flex items-baseline justify-between mb-1">
        <span className="text-[10px] mono uppercase tracking-widest text-[#94a3b8]">{label}</span>
        {unit && <span className="text-[10px] mono text-[#64748b]">{unit}</span>}
      </div>
      <input
        data-testid={testid}
        type={type}
        inputMode={type === "number" ? "decimal" : undefined}
        step="any"
        className={inputCls}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
    </label>
  );
}

function Group({ title, children }) {
  return (
    <div className="border border-[#334155] bg-[#11151c]">
      <div className="px-4 py-2 border-b border-[#334155] mono text-[10px] tracking-[0.25em] text-[#f59e0b]">{title}</div>
      <div className="p-4 grid grid-cols-2 lg:grid-cols-3 gap-3">{children}</div>
    </div>
  );
}

export function TallyHeader({ header, setHeader, fluids, setFluids }) {
  const h = (k) => (v) => setHeader({ ...header, [k]: v });
  const f = (k) => (v) => setFluids({ ...fluids, [k]: v });
  const T = (k, label, extra = {}) => <Field key={k} label={label} value={header[k]} onChange={h(k)} testid={`tally-${k}`} {...extra} />;
  const N = (k, label, unit) => <Field key={k} label={label} unit={unit} type="number" value={header[k]} onChange={h(k)} testid={`tally-${k}`} />;
  const F = (k, label, unit) => <Field key={k} label={label} unit={unit} type="number" value={fluids[k]} onChange={f(k)} testid={`tally-${k}`} />;
  return (
    <div data-testid="tally-header" className="grid gap-4 xl:grid-cols-2">
      <Group title="WELL INFO">
        {T("company", "Company")}
        {T("well_name", "Well name")}
        {T("rig", "Rig")}
        {T("field", "Field / County")}
        {T("api_no", "API / Well no.")}
        {T("date", "Date", { type: "date" })}
      </Group>
      <Group title="STRING">
        <label className="block">
          <div className="text-[10px] mono uppercase tracking-widest text-[#94a3b8] mb-1">String type</div>
          <select data-testid="tally-string-type" className={inputCls} value={header.string_type} onChange={(e) => h("string_type")(e.target.value)}>
            {Object.entries(STRING_TYPES).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
          </select>
        </label>
        {T("string_desc", "Pipe description", { placeholder: '5" 19.5# S-135 NC50' })}
        {N("string_od", "Pipe OD", "in")}
        {N("string_id", "Pipe ID", "in")}
        {N("offset", "Depth adjust (KB / stick-up)", "ft")}
        {N("td", "Hole TD (MD)", "ft")}
      </Group>
      <Group title="CASING & HOLE">
        {T("casing_desc", "Casing description", { placeholder: '9-5/8" 47# N-80 BTC' })}
        {N("casing_od", "Casing OD", "in")}
        {N("casing_id", "Casing ID", "in")}
        {N("shoe_md", "Shoe depth (MD)", "ft")}
        {N("open_hole", "Open hole size", "in")}
      </Group>
      <Group title="FLUIDS & PUMP">
        {F("mw_annulus", "Mud weight (annulus)", "ppg")}
        {F("mw_pipe", "Fluid in pipe", "ppg")}
        {F("slug_weight", "Slug weight", "ppg")}
        {F("slug_volume", "Slug volume", "bbl")}
        {F("tvd", "TVD at bit (blank = MD)", "ft")}
        {F("pump_output", "Pump output", "bbl/stk")}
      </Group>
    </div>
  );
}
